import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const RecordingFullscreenSnapshot = Schema.Struct({ active: Schema.Boolean, error: Schema.NullOr(Schema.String) });
export type RecordingFullscreenSnapshot = typeof RecordingFullscreenSnapshot.Type;
export class RecordingFullscreenFailure extends privateDependencyFailure<RecordingFullscreenFailure>()("RecordingFullscreenFailure", "recording-fullscreen") {}
export const recordingFullscreenFailure = (cause: unknown) => new RecordingFullscreenFailure({ cause: Redacted.make(cause) });
export type RecordingFullscreenObservation = { readonly _tag: "Active"; readonly value: unknown } | { readonly _tag: "Failed"; readonly failure: RecordingFullscreenFailure };
